module.exports = __webpack_public_path__ + "static/img/6510_phase_function_Paper_Points.ab55166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6510_phase_function_Paper_Points.png
// module id = CbL0
// module chunks = 0